module.exports = __webpack_public_path__ + "static/media/footer-phone.c26c1f5e.svg";